import { useContext, useMemo } from 'react';
import { useAuthContext } from 'shared/contexts/AuthContext';
import SettingsContext from '../contexts/SettingsContext';
import useRoutes, { LayoutsE } from '../routes';
import { RoleE } from 'shared/api/types/auth';

const useGetRoutes = (layout: LayoutsE) => {
  const { isDevMode } = useContext(SettingsContext);
  const { self } = useAuthContext();
  const routes = useRoutes();

  return useMemo(
    () => {
      const currLayout = routes[layout];
      const newRoutes = currLayout.groups
        .flatMap((group) => group.routes)
        // .filter((route) => (isDevMode ? true : !route.isDisabled))
        .filter(() => currLayout.isHideInAuth === !self)
        .filter(({ access }) => {
          if (!access) return true;
          if (!access.length && self.role === RoleE.ADMIN) return true;
          return access.includes(self.role);
        })

      return {
        routes: newRoutes,
        redirectUrl: `/${layout}/${newRoutes.length ? newRoutes[0].path : ''}`,
      };
    },
    [layout, isDevMode, self, routes],
  );
};

export default useGetRoutes;
